"use client";

import {
  FieldControl,
  FieldError,
  FieldLabel,
  FieldRoot,
} from "@tillix/ui-atoms/field";
import { Fieldset } from "@tillix/ui-atoms/fieldset";
import { Input } from "@tillix/ui-atoms/input";
import { Controller, useFormContext } from "react-hook-form";
import type { NigoFormValues } from "../types";

function formatSSN(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 9);
  if (digits.length <= 3) return digits;
  if (digits.length <= 5) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
}

const ssnRegex = /^\d{3}-?\d{2}-?\d{4}$/;

export default function SsnSection() {
  const { control } = useFormContext<NigoFormValues>();

  return (
    <Fieldset className="max-w-full">
      <Fieldset.Legend>Social Security Number</Fieldset.Legend>

      <Controller
        control={control}
        name="ssn"
        render={({ field, fieldState }) => (
          <FieldRoot invalid={!!fieldState.error} name={field.name}>
            <FieldLabel>SSN</FieldLabel>
            <FieldControl
              render={(defaultProps) => (
                <Input
                  {...defaultProps}
                  autoComplete="off"
                  className={defaultProps.className ?? ""}
                  inputMode="numeric"
                  maxLength={11}
                  name={field.name}
                  onBlur={field.onBlur}
                  onChange={(e) => {
                    field.onChange(formatSSN(e.target.value));
                  }}
                  placeholder="XXX-XX-XXXX"
                  ref={field.ref}
                  style={defaultProps.style ?? {}}
                  value={field.value}
                />
              )}
            />
            {fieldState.error && (
              <FieldError match={true}>{fieldState.error.message}</FieldError>
            )}
          </FieldRoot>
        )}
        rules={{
          required: "SSN is required",
          pattern: {
            value: ssnRegex,
            message: "Enter a valid SSN (XXX-XX-XXXX)",
          },
        }}
      />
    </Fieldset>
  );
}
